'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FadeIn } from '@/app/components/FadeIn'

export default function Projects() {
  const cards = [
  {
    title: 'Shop Fitout',
    img: '/hk/hk13.webp',   
    href: '/services/shop-fitout',
  },
  {
    title: 'Residential Construction',
    img: '/home.webp',       
    href: '/services/residential-construction',
  },
  
]

return (
  <main
  id="services"
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 lg:mb-16"
>
    {cards.map((card, i) => (
      <FadeIn key={card.title} delay={i * 0.1} y={30}>
        <Link
          href={card.href}
          className="group block w-full"
        >
          <div className="relative lg:aspect-[1/1] aspect-[1/2] overflow-hidden shadow-lg">
            <Image
              src={card.img}
              alt={card.title}
              fill
              className="object-cover transition-transform duration-700 group-hover:scale-105"
            />

            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-500" />

            <div className="absolute inset-0 flex items-center justify-center">
              <span className="
                text-md sm:text-lg lg:text-2xl xl:text-3xl 2xl:text-5xl
                font-bold text-white
                opacity-100 lg:opacity-0 lg:group-hover:opacity-100
                transition-opacity duration-500
              ">
                {card.title}
              </span>
            </div>
          </div>
        </Link>
      </FadeIn>

    ))}
  </main>
)
}
